export default function GalleryHero() {
  return (
    <>
      <div className="hero gallery-hero">
        <section className="overlay">
          <div className="max-width">
            <h1 className="heading text-center">
              Browse <span>Our Gallery</span>
            </h1>
            <p className="text-white mt-5 text-center">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit,
              deleniti!
            </p>
          </div>
        </section>
      </div>
    </>
  )
}
